import { useState, useEffect } from "react";

const MINIFIED_STORAGE_KEY = "instructions-minified";
const COMPLETED_STORAGE_KEY = "instructions-completed";
const CURRENT_STEP_STORAGE_KEY = "instructions-current-step";

export const useInstructions = (initialStep = 1, stepsLength: number) => {
  // Initialize isMinified from sessionStorage
  const getInitialMinifiedState = (): boolean => {
    if (typeof window !== "undefined") {
      const stored = sessionStorage.getItem(MINIFIED_STORAGE_KEY);
      return stored === "true";
    }
    return false;
  };

  // Initialize isCompleted from sessionStorage
  const getInitialCompletedState = (): boolean => {
    if (typeof window !== "undefined") {
      const stored = sessionStorage.getItem(COMPLETED_STORAGE_KEY);
      return stored === "true";
    }
    return false;
  };

  // Initialize currentStep from sessionStorage
  const getInitialCurrentStep = (): number => {
    if (typeof window !== "undefined") {
      const stored = sessionStorage.getItem(CURRENT_STEP_STORAGE_KEY);
      if (stored) {
        const parsedStep = parseInt(stored, 10);
        // Ensure the step is within valid range
        if (parsedStep >= 1 && parsedStep <= stepsLength) {
          return parsedStep;
        }
      }
    }
    return initialStep;
  };

  const [currentStep, setCurrentStep] = useState(getInitialCurrentStep);
  const [isMinified, setIsMinified] = useState<boolean>(getInitialMinifiedState);
  const [isCompleted, setIsCompleted] = useState<boolean>(getInitialCompletedState);

  // Save currentStep to sessionStorage whenever it changes
  useEffect(() => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem(CURRENT_STEP_STORAGE_KEY, currentStep.toString());
    }
  }, [currentStep]);

  // Save isMinified state to sessionStorage whenever it changes
  useEffect(() => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem(MINIFIED_STORAGE_KEY, isMinified.toString());
    }
  }, [isMinified]);

  // Save isCompleted state to sessionStorage whenever it changes
  useEffect(() => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem(COMPLETED_STORAGE_KEY, isCompleted.toString());
    }
  }, [isCompleted]);

  const nextStep = () => {
    setCurrentStep((step) => (step < stepsLength ? step + 1 : stepsLength));
  };

  const setStep = (step: number) => setCurrentStep(step);

  const onMinify = () => {
    if(currentStep === stepsLength && !isCompleted) {
      setIsCompleted(true);
      setIsMinified(true);
    } else {          
    setIsMinified(!isMinified);
    }
  };
  

  return {
    currentStep,
    nextStep,
    setStep,
    onMinify,
    isMinified,
    isCompleted
  };
};
